import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Icon } from '../icons';
import styles from './SignUpPage.module.scss';

const features = [
	{
		icon: 'lightning-bolt',
		title: 'Easy to get started',
		description: 'Sign up in minutes and be up and running fast.',
	},
	{
		icon: 'vendor',
		title: 'Real human support',
		description: 'From a team that knows the industry.',
	},
	{
		icon: 'credit-card',
		title: 'Flexible processing fees',
		description: 'Choose to absorb the fees, pass it along, or split the fees.',
	},
];

export const WmbaCampaignBrand = () => (
	<Box className={ styles.campaignBrand }>
		<Typography className={ styles.partnerWordmark }>
			Rock Paper Coin x Wedding MBA
		</Typography>
	</Box>
);

export const WmbaCampaignIntro = () => (
	<Box className={ styles.campaignIntroCopy }>
		<Typography className={ styles.campaignHeading }>
			From inquiry to payment,
			<br />
			<Box component='span'>all in one place.</Box>
		</Typography>
		<Typography className={ styles.campaignDescription }>
			Rock Paper Coin makes it easy for wedding and event pros to manage
			inquiries, proposals, contracts, invoices, and payments without juggling
			multiple tools. Simple software, backed by real people who care about your
			business.
		</Typography>
		<Box className={ styles.campaignFeatures }>
			{ features.map( ( feature ) => (
				<Box className={ styles.campaignFeature } key={ feature.title }>
					<Box className={ styles.featureIcon }>
						<Icon type={ feature.icon } aria-hidden='true' />
					</Box>
					<Typography className={ styles.featureTitle }>
						{ feature.title }
					</Typography>
					<Typography className={ styles.featureDescription }>
						{ feature.description }
					</Typography>
				</Box>
			) ) }
		</Box>
	</Box>
);

export const WmbaOffer = () => (
	<Box className={ styles.offer }>
		<Icon type='ticket' aria-hidden='true' />
		<Typography>
			Use code <strong>WMBA26</strong> for <strong>30% off</strong> your first
			year.
		</Typography>
	</Box>
);

export const WmbaSupport = () => (
	<Box className={ styles.support }>
		<Icon type='mail' aria-hidden='true' />
		<Box>
			<Typography>Questions? We’re here to help.</Typography>
			<Typography className={ styles.supportLinks }>
				<Link href='mailto:hello@rockpapercoin.com'>
					hello@rockpapercoin.com
				</Link>
				<Box component='span' aria-hidden='true' className={ styles.span }>
					|
				</Box>
				<Link href='tel:+15034761796'>(503) 476-1796</Link>
			</Typography>
		</Box>
	</Box>
);
